
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/okta",
      function () {
        return require("private-next-pages/auth/okta.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/okta"])
      });
    }
  